module.exports = __webpack_public_path__ + "img/img_target_left_bf.c6260878.svg";